import PropTypes from 'prop-types'
import withSideEffect from 'react-side-effect'
import ClientSideRaven from 'raven-js'

const STRUC_DATA_ID = 'structured-data-react-sg-dxg'

/*

N.B. The reason for the complexity of this component compared to the
straightforward use of react-helmet to handle the similar use cases
(of <title/> etc.) is discussed in some detail here:

https://github.com/ScentreGroup/checkout_client/pull/530

*/

const reduceMetaLastObj = data => {
  if (!data) {
    return null
  }
  const len = data.length
  if (len === 0) {
    return null
  }
  const innermost = data[len - 1]

  if (!innermost || Object.keys(innermost).length === 0) {
    return null
  } else {
    return innermost
  }
}

export function reducePropsToState(propsList = []) {
  const DATA_TYPES = ['structuredData', 'openGraphData']
  const allData = {}
  DATA_TYPES.forEach(dataType => {
    allData[dataType] = reduceMetaLastObj(
      propsList.map(item => item.data[dataType])
    )
  })
  return allData
}

export function handleStateChangeOnClient(data) {
  try {
    let elem = document.getElementById(STRUC_DATA_ID)
    if (data.structuredData) {
      if (!elem) {
        elem = document.createElement('script')
        elem.setAttribute('type', 'application/ld+json')
        elem.setAttribute('id', STRUC_DATA_ID)
        document.head.appendChild(elem)
      }
      elem.innerHTML = JSON.stringify(data.structuredData)
    } else if (elem && elem.parentNode !== null) {
      elem.parentNode.removeChild(elem)
    }
  } catch (e) {
    // Just log - better to leave structured data in a potentially
    // invalid state than to create a user visible error on the page
    ClientSideRaven.captureException(e, { extra: 'Structured data error' })
  }
}

function mapStateOnServer(data) {
  return data
}

const ComponentMetaDataNoSideEffect = ({ data }) => null

ComponentMetaDataNoSideEffect.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}

const ComponentMetaData = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient,
  mapStateOnServer
)(ComponentMetaDataNoSideEffect)

const getOpenGraphElements = openGraphData =>
  Object.entries(openGraphData)
    .map(
      centreProp =>
        `<meta property="og:${centreProp[0]}" content="${centreProp[1]}"/>`
    )
    .join('')

ComponentMetaData.renderStaticToString = () => {
  try {
    let appendMetaData = ''
    const metaData = ComponentMetaData.rewind()
    if (metaData) {
      const jsonStructuredData = JSON.stringify(metaData.structuredData)
      if (jsonStructuredData) {
        appendMetaData = `${appendMetaData}<script type="application/ld+json" id="${STRUC_DATA_ID}">${jsonStructuredData}</script>`
      }
      if (metaData.openGraphData) {
        appendMetaData =
          appendMetaData + getOpenGraphElements(metaData.openGraphData)
      }
    }
    return appendMetaData
  } catch (e) {
    // Leave the client code in charge of failed renders:
    return null
  }
}

export default ComponentMetaData
